import Vue from 'vue'
import App from './App.vue'
import router from './router'
// import axios from 'axios'
import store from './store'
import ViewUI from 'view-design'
import 'view-design/dist/styles/iview.css'
import { Menu, Submenu, MenuItem, MenuItemGroup, Tooltip, Image } from 'element-ui'
import 'element-ui/lib/theme-chalk/base.css'
// collapse 展开折叠
import CollapseTransition from 'element-ui/lib/transitions/collapse-transition'

Vue.component(CollapseTransition.name, CollapseTransition)

Vue.use(Menu)
Vue.use(Submenu)
Vue.use(MenuItem)
Vue.use(MenuItemGroup)
Vue.use(Tooltip)
Vue.use(Image)
Vue.use(ViewUI)
Vue.config.productionTip = false

// axios.defaults.baseURL = 'https://www.jiexiong19.cn/api/Backstage/'
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
